import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { PointOptionsObject } from 'highcharts';
import { ShiftSchedulingStat } from '../../../../types';

@Component({
  selector: 'lohi-missed-shifts',
  templateUrl: './missed-shifts.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MissedShiftsComponent implements OnInit {
  @Input() private shifts: ShiftSchedulingStat[];
  @Input() private days: number;
  private sortedShifts: ShiftSchedulingStat[];

  public labels: Array<string>;
  public chart: Chart;

  constructor(private router: Router) {}

  public ngOnInit(): void {
    this.sortedShifts = this.shifts
      .slice()
      .filter((value) => value.cancelPercentage !== 0)
      .sort((a, b) => b.cancelPercentage - a.cancelPercentage);
    this.labels = this.sortedShifts.map((value) => value.userName);
    this.chart = new Chart({
      chart: {
        type: 'column',
      },
      title: {
        align: 'left',
        useHTML: true,
        text: `<div class="text-lg font-bold">Missed or Cancelled Shifts <span class="text-blue-500">${this.days}d</span></div>`,
      },
      credits: {
        enabled: false,
      },
      yAxis: [
        {
          title: null,
          max: 100,
        },
      ],
      plotOptions: {
        series: {
          events: {
            click: (event) => {
              if (!event.point.options.custom.userId) {
                return;
              }
              this.router.navigate(['drivers', event.point.options.custom.userId]);
            },
          },
        },
      },
      xAxis: {
        type: 'category',
        categories: this.labels,
        visible: true,
      },
      series: [],
      tooltip: {
        formatter() {
          return (
            `<span class="font-bold" style="color: ${this.point.color}">` + this.series.name + '</span> ' + this.y + '%'
          );
        },
      },
    });
    const missedShifts: Array<[string, number] | PointOptionsObject> = [];
    for (const entry of this.sortedShifts) {
      missedShifts.push({
        label: entry.userName,
        custom: {
          userId: entry.userId,
        },
        y: entry.cancelPercentage,
      });
    }
    this.chart.addSeries(
      {
        name: 'Missed or Cancelled Shifts',
        type: 'column',
        color: '#EF6048',
        data: missedShifts,
      },
      true,
      true,
    );
  }
}
